(() => {
  const all = (selector, root = document) => Array.from((root || document).querySelectorAll(selector))
  const html = document.documentElement
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

  const hideStorefrontChrome = () => {
    all("#dtf-sticky-cta, #dtf-section-dots, #dtf-mascot, #dtf-mascot-restore, #dtf-checkout-tap-overlay, .dtf-progress-wrap").forEach(element => {
      element.style.setProperty("display", "none", "important")
      element.setAttribute("aria-hidden", "true")
    })
  }

  hideStorefrontChrome()
  window.addEventListener("load", hideStorefrontChrome, { once: true })

  const saveData = Boolean(navigator.connection?.saveData)
  all("[data-fsx-video]").forEach(video => {
    if (reducedMotion || saveData) return
    let loaded = false
    const load = () => {
      if (loaded) return
      loaded = true
      video.src = window.innerWidth < 750 ? video.dataset.mobileSrc : video.dataset.desktopSrc
      video.load()
      video.play().catch(() => {})
    }
    if (!("IntersectionObserver" in window)) {
      window.setTimeout(load, 800)
      return
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          load()
          video.play().catch(() => {})
        } else if (loaded) video.pause()
      })
    }, { rootMargin: "300px 0px", threshold: 0.01 })
    observer.observe(video)
  })

  all("[data-fsx-faq]").forEach(faq => {
    all(".fsx-faq__item button", faq).forEach(button => {
      button.addEventListener("click", () => {
        const item = button.closest(".fsx-faq__item")
        const open = item.classList.toggle("is-open")
        button.setAttribute("aria-expanded", String(open))
      })
    })
  })

  const funnel = document.querySelector("[data-dtfs-free-sample]")
  let landingScroll = 0
  let restoring = false

  const syncFunnelPresentation = () => {
    if (!funnel) return
    const committed = Boolean(funnel.dataset.currentScreen && funnel.dataset.currentScreen !== "experience")
    const wasCommitted = html.classList.contains("fs-alternative-committed")
    html.classList.toggle("fs-alternative-committed", committed)
    if (!committed && wasCommitted && !restoring) {
      restoring = true
      window.requestAnimationFrame(() => {
        window.scrollTo({ top: landingScroll, behavior: reducedMotion ? "auto" : "smooth" })
        restoring = false
      })
    }
  }

  if (funnel) {
    new MutationObserver(syncFunnelPresentation).observe(funnel, { attributes: true, attributeFilter: ["data-current-screen"] })
    syncFunnelPresentation()
  }

  const sticky = document.querySelector("[data-fsx-sticky]")
  const updateSticky = () => {
    const question = document.querySelector("#dtfs-fs-question")
    const rect = question?.getBoundingClientRect()
    const questionVisible = Boolean(rect && rect.top < window.innerHeight - 72 && rect.bottom > 72)
    sticky?.classList.toggle("is-visible", window.scrollY > 620 && !questionVisible)
  }

  window.addEventListener("scroll", updateSticky, { passive: true })
  window.addEventListener("resize", updateSticky)
  updateSticky()

  document.addEventListener("click", event => {
    const cta = event.target.closest("[data-fs-funnel-cta]")
    if (cta) {
      event.preventDefault()
      document.querySelector("#dtfs-fs-question")?.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" })
      return
    }
    if (event.target.closest('[data-answer="experience"]')) landingScroll = window.scrollY
  })
})()
